<!--
  活动市场 · 管理端门户（对接 /market/portal + /promotion/activity）
-->
<template>
  <MarketPortal />
</template>

<script lang="ts" setup>
import MarketPortal from '../portal/index.vue'

defineOptions({ name: 'MarketHome' })
</script>
